// extracted by mini-css-extract-plugin
export default {"mediaQueries":"\"../styles/mediaQueries.css\"","mqLarge":"only screen and (min-width: 1025px)","wrapper":"Home_wrapper__87nFZ","h3":"Home_h3__kSm3s"};